export default {
  volunteer: {},
};
